const REPEAT_OPTIONS = {
  '1,2,3,4,5,6,7': {key: 'listings.repeat.daily', fallback: 'Daily'},
  '2,3,4,5,6': {key: 'listings.repeat.weekdays', fallback: 'Weekdays (Mon-Fri)'},
  '1,7': {key: 'listings.repeat.weekend', fallback: 'Weekend (Sat-Sun)'},
  '': {key: 'listings.repeat.custom', fallback: 'Custom'},
};

const WEEKDAYS = {
  1: {key: 'listings.weekday.sun', fallback: 'Sun'},
  2: {key: 'listings.weekday.mon', fallback: 'Mon'},
  3: {key: 'listings.weekday.tue', fallback: 'Tue'},
  4: {key: 'listings.weekday.wed', fallback: 'Wed'},
  5: {key: 'listings.weekday.thu', fallback: 'Thu'},
  6: {key: 'listings.weekday.fri', fallback: 'Fri'},
  7: {key: 'listings.weekday.sat', fallback: 'Sat'},
};

export const translateWeekday = (day, t) => {
  const option = WEEKDAYS[day];
  return option ? t(option.key, option.fallback) : String(day ?? '');
};

export const translateRepeatOption = (repeatIds, t) => {
  const option = REPEAT_OPTIONS[String(repeatIds ?? '')];
  return option ? t(option.key, option.fallback) : translateRepeatSchedule(repeatIds, t);
};

export const translateRepeatSchedule = (repeatIds, t) => {
  const normalized = String(repeatIds ?? '');
  const option = REPEAT_OPTIONS[normalized];
  if (option) return t(option.key, option.fallback);
  return normalized
    .split(',')
    .filter(Boolean)
    .map(day => translateWeekday(Number(day), t))
    .join(', ');
};
